import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import CircularLoading from '../ui/CircularLoading';
import { logEvent } from '../../new-lib/analytics';
import { getPageLocation } from '../../helpers/common';
import { useRouter } from 'next/router';

interface loadMorePresentationProps {
  loadedDataLength: number;
  limit: number;
  isLoading: boolean;
  handleLoadMore: () => void;
}
const LoadMorePresentation = ({
  loadedDataLength,
  limit,
  handleLoadMore,
  isLoading
}: loadMorePresentationProps) => {
  const { t } = useTranslation('common');
  const { asPath } = useRouter();
  const handleClick = () => {
    if (asPath.startsWith('/new-launches')) {
      logEvent.click('lnch_load_more', getPageLocation(asPath), 'launches');
    }
  };

  return loadedDataLength < limit ? (
    <Container className="load-more" onClick={handleClick}>
      <button onClick={handleLoadMore} disabled={isLoading}>
        {isLoading ? (
          <CircularLoading width="20px" height="20px" />
        ) : (
          <>
            <span>{t('load_more')} </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
            >
              <path
                d="M12.9405 1.21191L8.05055 6.10191C7.47305 6.67941 6.52805 6.67941 5.95055 6.10191L1.06055 1.21191"
                stroke="#015C9A"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )}
      </button>
    </Container>
  ) : null;
};

const Container = styled.div`
  width: 100%;

  button {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 45px;
    border: none;
    font-family: materialRegular;
    color: #015c9a;
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
  }

  @media screen and (max-width: 768px) {
    button {
      font-size: 14px;
    }
  }
`;

export default LoadMorePresentation;
